(function ($) {

	/* MAIN MENU NESTED BEHAVIOUR */
	$('<a class="next"></a>').insertBefore('.westsystem-categories-menu ul.children').parent();
	$('.westsystem-categories-menu > ul, .westsystem-categories-menu ul.children').each(function() {
		$(this).children('li.cat-item').wrapAll('<li class="menu-children"><ul class="menu-children-list" /></li>');
	});
	// Add category title.
	$('.westsystem-categories-menu ul.children').each(function() {
		$(this).prepend('<li class="header"><header class="title">' + $(this).parent().find('a:not(.next)').first().text() + '</header>');
	});
	// Create back buttons.
	const back = jQuery('<a>').prop('href', '#').addClass('back');
	$('ul.children li.header').prepend(back);
	// Add close icon to categories menu.
	$('.westsystem-categories-menu li.header.top-level').append('<a href="#" class="westsystem-menu-close suki-popup-close"></a>');
	// Create a parent category link for categories menu.
	document.querySelectorAll('.cat-item-all').forEach(element => {
		const href = element.closest('.children').closest('li.cat-item').querySelector('a').getAttribute('href');
		element.querySelector('a').setAttribute('href', href);
	});

	// Open/close sub category.
	$('.next').click(function(e) {
		e.preventDefault();
		var nxtBtn = $(this);
		var currMenu = nxtBtn.closest('.menu-children').closest('ul');
		var parentMenuWidth = 0;
		var currMenuWidth = 0;
		var parentWidth = 0;
		var mainMenuWidth = $('.westsystem-categories-menu > ul').width();
		if ( nxtBtn.next().hasClass('active') ) {
			// Close already open sub menu.
			currMenu.find('li.open').removeClass('open');
			nxtBtn.next().removeClass('active').removeClass('visible').removeClass('rotate').slideUp(0);
			nxtBtn.parents('ul.children').each( function() {
				parentMenuWidth += $(this).width();
			});
			$('.suki-header-vertical-bar.suki-popup-content').width( mainMenuWidth + parentMenuWidth + currMenuWidth - 2 );
		} else {
			// Open sub menu and set position dynamically to position next to parent menu. Not ideal, but works.
			$('.westsystem-categories-menu > ul').addClass('child-menu-open');
			currMenu.find('li .children').hide().removeClass('active');
			$('.westsystem-categories-menu ul.visible').removeClass('visible');
			currMenu.find('li.open').removeClass('open');
			currMenu.not('.child-menu-open').addClass('two-levels');
			nxtBtn.next().addClass('visible');
			nxtBtn.next().toggleClass('active');
			nxtBtn.parent('li').addClass('open');
			parentWidth = nxtBtn.closest('.menu-children').width();
			nxtBtn.next().css( 'left', parentWidth + 'px' );
			nxtBtn.next().slideToggle(0);
			currMenuWidth = mainMenuWidth;
			nxtBtn.parents('ul.children').each( function() {
				parentMenuWidth += $(this).width();
			});
			$('.suki-header-vertical-bar.suki-popup-content').width( mainMenuWidth + parentMenuWidth + currMenuWidth - 2 );
			$('.suki-header-mobile-vertical-bar-top .suki-header-search-bar').css({
				'position': 'absolute',
				'top': $('ul.children.active > .menu-children').last().height() + 70,
			});
		}
	});
	// Back button click handling.
	$('.back').click(function(e) {
		e.preventDefault();
		e.stopPropagation();
		var bckBtn = $(this);
		var thisMenu = bckBtn.closest('.children');
		var nextMenu = bckBtn.closest('.menu-children').closest('ul');
	 	if ( nextMenu.hasClass('child-menu-open') ) {
			nextMenu.removeClass('child-menu-open');
		} else {
			nextMenu.addClass('active').addClass('visible').show();
		}
		thisMenu.parent().removeClass('open');
		thisMenu.removeClass('active').removeClass('visible').hide();
		$('.suki-header-mobile-vertical-bar-top .suki-header-search-bar').css({
			'position': 'absolute',
			'top': $('.westsystem-categories-menu > ul > .menu-children, ul.children.active > .menu-children').last().height() + 70,
		});
	});
	// Add close button event handler to close open sub-menus.
	$('.westsystem-categories-menu .header').on( "click touchend", ".westsystem-menu-close", function(e) {
		setTimeout(function() {
			$('.westsystem-categories-menu li.open').removeClass('open');
			$('.westsystem-categories-menu ul.active').removeClass('active').removeClass('visible');
			$('.westsystem-categories-menu > ul').removeClass('child-menu-open');
			$('.westsystem-categories-menu > ul.children.two-levels').removeClass('two-levels');
			$('.westsystem-categories-menu ul.children').hide();
			$('.suki-header-vertical-bar').css('width', 'auto');
			$('.suki-header-mobile-vertical-bar-top .suki-header-search-bar').css({
				'position': 'relative',
				'top': 'auto',
			});
		}, 250);
	});


	$('#mobile-header').on( "click touchend", "button[data-target='mobile-vertical-header']", function(e) {
		$('body').addClass('menu-open');
	});

})(jQuery);
